import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import * as _ from 'lodash';
import { IExpense } from "./expenses.interface";
import { HttpService } from "../../../../http.service";
import { UtilsService } from "../../../shared/services/utils.service";
import { apiURL, EnvConfig } from "../../../../env-config";

@Injectable()
export class ExpensesService {
  constructor(
    private _http: HttpService,
    private _utilsService: UtilsService,
  ) { }

  getExpenses(filter?: any): Observable<any> {
    let queryParams: string = !_.isEmpty(filter) ? '?' + this._utilsService.toQueryString(filter) : '';
    return this._http.get(`${apiURL(EnvConfig.API_EXPENSES)}${queryParams}`);
  }

  getExpense(product: IExpense | string): Observable<any> {
    let id = (typeof product == 'string') ? product : product._id;
    return this._http.get(`${apiURL(EnvConfig.API_EXPENSES)}/${id}`);
  }

  createExpense(product: IExpense): Observable<any> {
    return this._http.post(`${apiURL(EnvConfig.API_EXPENSES)}`, product);
  }

  updateExpense(product: IExpense): Observable<any> {
    let id = product._id;
    delete product._id;
    return this._http.patch(`${apiURL(EnvConfig.API_EXPENSES)}/${id}`, product);
  }

  deleteExpense(product: IExpense | string, hardDelete: boolean = false): Observable<void> {
    let id = (typeof product == 'string') ? product : product._id;
    if (hardDelete) return this._http.delete(`${apiURL(EnvConfig.API_EXPENSES)}/${id}`);
    return this._http.delete(`${apiURL(EnvConfig.API_EXPENSES)}/${id}/delete`);
  }

  restoreExpense(product: IExpense | string): Observable<void> {
    let id = (typeof product == 'string') ? product : product._id;
    return this._http.post(`${apiURL(EnvConfig.API_EXPENSES)}/${id}/restore`, null);
  }
}